import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { reviewByReleaseId, createReview } from '../../actions/review';
import ReviewForm from '../ReviewForm';

class ReleaseReviewForm extends PureComponent {
  static propTypes = {
    releaseId: PropTypes.number.isRequired,
    reviewByReleaseId: PropTypes.func.isRequired,
    createReview: PropTypes.func.isRequired,
  };

  state = {
    loading: false,
  };

  handleFormSubmit = (err, values) => {
    this.setState({ loading: true });

    return this.props.createReview({
      reviewData: values.message,
      reviewerName: values.username,
      reviewRate: values.rate,
      releaseId: this.props.releaseId,
    })
      .then(() => {
        this.props.reviewByReleaseId({
          releaseId: this.props.releaseId,
        });

        this.setState({
          loading: false,
        });
      })
      .catch(({ body }) => {
        this.setState({
          loading: false,
        });

        // eslint-disable-next-line prefer-promise-reject-errors
        return Promise.reject({
          username: body.reviewerName,
          message: body.reviewData,
        });
      });
  };

  render() {
    return (
      <ReviewForm
        labels={{
          rate: 'Rate this release',
        }}
        loading={this.state.loading}
        onSubmit={this.handleFormSubmit}
        submitTitle="Add review"
      />
    );
  }
}

const mapDispatchToProps = {
  reviewByReleaseId,
  createReview,
};

export default connect(null, mapDispatchToProps)(ReleaseReviewForm);
